/* src/app/app.menu.component.scss */
body#themeTag :host ::ng-deep .layout-menu-dark :host li a {
  color: white;
}
body#themeTag :host ::ng-deep .layout-menu :host a span {
  display: inline-block;
  vertical-align: middle;
  font-size: 9px;
  margin-left: -12px;
}
body#themeTag :host ::ng-deep .p-checkbox-label {
  margin-bottom: 0 !important;
}
body#themeTag :host ::ng-deep .p-sidebar-close {
  color: #FF0000 !important;
  font-weight: bold !important;
  background-color: transparent !important;
  margin-right: -3.5em !important;
}
.ef-menuitem-badge-on a > span {
  float: right;
  width: auto;
  margin-right: 2px;
  text-align: center;
  background-color: #FF0000;
  color: #FFFFFF;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  border-radius: 3px;
  padding: 1px 5px;
  margin-top: -2.4em;
  margin-right: -0.1em;
  position: relative;
}
.ef-menuitem-badge-off a > span {
  display: none;
}
/*# sourceMappingURL=app.menu.component.css.map */
